/**
 * Given frequency data, compares it with previous entries to detect silence.
 */
export function isSilence(current: number[], previous: number[][]) {
  if (current.filter(value => value > 20).length < 4) {
    return true;
  }

  if (!previous.length) {
    return false;
  }

  if (current.join(' ') !== previous[previous.length - 1].join(' ')) {
    return false;
  }

  for (let i = 0; i < Math.min(previous.length, 20); i++) {
    if (previous[previous.length - 1 - i].join(' ') !== current.join(' ')) {
      return false;
    }
  }

  return true;
}